import React from 'react';

const ArticleHero = ({ title }) => {
  return (
    <section className="relative py-12 bg-gradient-to-br from-[#089556] via-[#07D1EB] to-[#0ba8c7] overflow-hidden">
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="max-w-4xl mx-auto px-4 relative z-10">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            {title}
          </h1>
        </div>
      </div>
    </section>
  );
};

export default ArticleHero;